<template>
  <div class="stage-level-detail pa-3">
    <div class="caption text--secondary">
      {{ selectedObservatory.address }}
    </div>
    <div class="caption text--secondary">
      {{ selectedObservatory.lat }}, {{ selectedObservatory.lng }}
    </div>

    <template v-if="isDeficit">
      <div class="mt-5 caption">この観測所は欠測しています。</div>
    </template>

    <template v-else>
      <v-btn-toggle v-model="displayInterval" mandatory dense class="my-2">
        <v-btn small :value="10">
          10分毎
        </v-btn>
        <v-btn small :value="60">
          時間毎
        </v-btn>
        <v-btn small :value="24">
          24時間毎
        </v-btn>
      </v-btn-toggle>

      <div class="caption ml-2 my-1">（m）</div>
      <RainTankChart
        :height="240"
        :selected-observatory="selectedObservatory"
        :displayInterval="displayInterval"
      />

      <v-simple-table dense class="mt-3">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">日時</th>
              <th class="text-left">水位 (m)</th>
              <th style="width: 100px"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(ts, index) in timeSeries" :key="index">
              <td>{{ ts.date }}</td>
              <td class="text-right">{{ ts.level }}</td>
              <td></td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
  </div>
</template>

<script>
import RainTankChart from "./RainTankChart";
import moment from "moment";

export default {
  name: "RainTankDetail",
  components: {
    RainTankChart
  },
  data() {
    return {
      displayInterval: 10
    };
  },
  computed: {
    selectedObservatory() {
      return this.$store.getters.selectedObservatory;
    },
    reals() {
      const timeSeries = this.selectedObservatory.timeSeries;
      if (timeSeries === undefined) {
        return [];
      } else {
        return timeSeries;
      }
    },
    currentDate() {
      const baseDate = this.$store.getters.baseDate.clone();
      return baseDate.subtract(baseDate.minute() % 10, "minutes");
    },
    isDeficit() {
      return this.reals.length === 0;
    },
    timeSeries() {
      const start = this.currentDate.clone();
      if (this.displayInterval === 10) {
        start.subtract(3, "hours");
      } else if (this.displayInterval === 60) {
        start.subtract(2, "days");
      } else {
        start.subtract(14, "days");
      }
      const displayStartTime = start.format("YYYY/MM/DD HH:mm");
      const displayLimitTime = this.currentDate.format("YYYY/MM/DD HH:mm");
      return this.selectedObservatory.timeSeries
        .filter(
          r =>
            r.date > displayStartTime &&
            r.date <= displayLimitTime &&
            (this.displayInterval === 10 ||
              (this.displayInterval === 60 && r.date.substr(-2) === "00") ||
              (this.displayInterval === 24 && r.date.substr(-5) === "15:00"))
        )
        .map(r => {
          const date = moment
            .utc(r.date, "YYYY/MM/DD HH:mm")
            .local()
            .format("MM/DD HH:mm");
          return {
            date: date,
            level:
              r.level !== undefined ? parseFloat(r.level).toFixed(2) : "---"
          };
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.stage-level-detail {
  thead {
    background-color: #addff3;
  }
  tbody td {
    background: #eee;
  }
  tbody tr:nth-child(odd) td {
    background: #fff;
  }
  .std-color {
    width: 16px;
    height: 12px;
    border-bottom: white 3px solid;
  }
  .predict {
    color: blue;
  }
}
</style>
